export const useCheckDomain = (domain?: string) => {
  const hostnames = ['selless.com']
  return domain ? hostnames.includes(domain) : process.browser && hostnames.includes(window.location.hostname)
}
